<template>
  <router-view />
</template>

<script>
export default {
  name: 'Tailorism',
  data() {
    return {
    }
  }
}
</script>

<style scoped>

</style>
